module.exports = __webpack_public_path__ + "img/009-crab.e9be36e6.svg";